/* eslint-disable */

import React, { useEffect, useState,useRef, useMemo } from "react";
import styled from "styled-components";
import { DateRangePickerComponent,PresetsDirective, PresetDirective  } from '@syncfusion/ej2-react-calendars';
import { useHistory } from 'react-router-dom';
import Svg from "_assets/svg";
import { channelConstant } from "_constant";
import H5 from "components/H5";
import H4 from "components/H4";
import H2 from "components/H2";
import Dropdown from "containers/DashboardPage/Dropdown";
import applicationSvc from "services/applicationSvc";
import reportSvc from "services/reportSvc";
import moment from "moment";
import Wrapper from "./Wrapper";
import LineGraphic from "./LineGraphic";
import Report from './Report';
import Table from "./TableData";
import InfoOverview from "_assets/icons/info.svg";

import { today,yesterday,formatDate,monthStart,weekEnd } from "utils/dateFormat";

import Close from "_assets/images/close.png";
import TitleV2 from "components/TitleV2";
import { Alert,AlertType } from "utils/Alert";

import './overview.scss';
import DetailTransactionData from "./DetailTransactionData";
import WhatsappSession from "./WhatsappSession";
import GraphicMultiLine from "./GraphicMultiLine";

import channelUsageSvc from 'services/channelUsageSvc';

const DivTitle = styled.div`
  @media only screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

const ButtonExport = styled.button`
  /* Frame 57 */

  /* Auto Layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafd 100%);
  border: 1px solid #bbc1c8;
  box-sizing: border-box;
  border-radius: 8px;
`;

const Icon = styled.img``;

const DivGraphic = styled.div`
  /* Rectangle 97 */
  background: #ffffff;
  // opacity: 0.8;
  border: 1px solid #d8dce1;
  box-sizing: border-box;
  border-radius: 8px;
`;

const ButtonProject = styled.button`
  /* Rectangle 99 */
  margin: 8px;

  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background: #f8f8f9;
  opacity: 0.8;
  border: 1px solid #d8dce1;
  box-sizing: border-box;
  border-radius: 8px;
  &:focus{
    outline: none;
  }
`;

const H3 = styled.span`
  /* Project Barongsai */

  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  color: #26292d;
`;


const Div = styled.div`
  /* Rectangle 98 */
  --bs-gutter-x: 0rem !important;
  position: relative;
  border-bottom: 2px solid ${(props) => (props.project ? "#EBECF0" : "#EBECF0")};
`;

const ButtonMenu = styled.button`
  padding-block: 25.2px;
  padding-inline: 0px;
  background: #ffffff;
  border: 0px;
  background: transparent;
  // border-bottom: 2px #EBECF0 solid;
  top: 2px;
  position: relative;
  &:focus{
    outline: none;
  }
  ${props => props.active && `
    border-bottom: 2px solid #26292D;
  `

  }
`;

const Detail = styled.div`
  position: relative;
  margin-top: 30px;
  margin-right: 0;
  min-width: 200px;
  padding: 20px;
  box-shadow: 1px 2px 5px 0px #3333331A;


  // background: ${(props) => (props.last ? "#F8F8F9" : "#FFFFFF")};
  // border: ${(props) => (props.last ? "" : "2px solid #C7CFD7")};
  box-sizing: ${(props) => (props.last ? "" : "border-box")};
  border-radius: 6px;
`;

const Label = styled.span`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;

  color: #26292d;
`;

const Value = styled.p`
  margin-top: 4px;

  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;

  // color: #26292d;
`;

const Percentage = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;

  color: ${(props) => (props.last ? "#D63358" : "#00855E")};
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

const LoadingPage = () => {
  const _renderLoading = () => {
    const loadingTemplate = [];
    for (let i = 0; i < 7; i += 1) {
      loadingTemplate.push(
        <div className="spinner-grow text-dark" style={{ margin: "10px" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      );
    }
    return loadingTemplate;
  };

  return <LoadingContainer>{_renderLoading()}</LoadingContainer>;
};

// const BadgeOverview = () => {
//   return (
//     <div className="wrapper_badge_overview">
//       <img
//         src={InfoOverview}
//         className=""
//         alt="info" 
//       />
//       Some data will be visualized by mixed, for each channel transaction, if you do some transactions before August.
//       However, the data should be displayed separately if you make a transaction in August.
//     </div>
//   )
// }

const DashboardPage = () => {
  const [applications, setApplications] = useState([]);
  const [report, setReport] = useState([]);
  const [meta, setMeta] = useState({});
  const [rangeDate, setRangeDate] = useState([new Date().setDate(new Date().getDate() - 7), new Date()]);
  const [isTextDate, setTextDate] = useState("Select date...")
  const [selectedChannel, setSelectedChannel] = useState({ index: 0, channelName: '' });
  const [selectedApplication, setSelectedApplication] = useState(-1);
  const [dropdown, setDropdown] = useState(false);
  const [xlsLoading, setXlsLoading] = useState(false);
  const [isDataLoading, setDataLoading] = useState(false);
  const [isDataUser, setDataUser] = useState([]);
  const applicationId = applications[selectedApplication]?._id;
  const startDateTemp = moment(rangeDate[0]).format("YYYY-MM-DD");
  const endDateTemp = moment(rangeDate[1]).format("YYYY-MM-DD");
  const [isFilterTable, setChannelTable] = useState({
    search:null || '',
    startDate: startDateTemp,
    endDate: endDateTemp,
    showType: '',
    // sortBy: 'created_at',
    limit: 5,
    page: 1,
    application_id: ''
  })
const [isStatusDate, setStatusDate] = useState(null);
const [isDataUsageChannel, setDataUsageChannel] = useState(null);
const container=useRef();

  const history = useHistory();
  useEffect(() => {
    applicationSvc.getAll().then((response) => {
      setApplications(response?.data?.data || [])
    }).catch(() => { });
  }, []);

  // console.log('dataku', applications[selectedApplication]?.channels, applications[selectedApplication]?.channels[selectedChannel?.index]?._id)
  // const channelId = applications[selectedApplication]?.channels && applications[selectedApplication]?.channels[selectedChannel?.index]?._id;

  // const getXlsData = () => {

  //   setXlsData([]);
  //   setXlsLoading(true);
  //   const tempData = [];
  //   const application = applications[selectedApplication];
  //   application?.channels?.map(async (val, i) => {
  //     try {
  //       const responseData = await reportSvc.getAll(val.id, applicationId, startDateTemp, endDateTemp);
  //       const { data } = responseData;
  //       tempData.push({
  //         applicationId: application.id,
  //         createdDate: application.createdAt,
  //         applicationName: application.applicationName,
  //         channelId: val._id,
  //         channelCode: val.channel,
  //         totalTransaction: data?.meta?.totalTransaction || 0,
  //         successRate: `${data?.meta?.successRate?.toFixed(2) || 0}%`,
  //         failedRate: `${data?.meta?.failedRate?.toFixed(2) || 0}%`,
  //         startDate: startDateTemp,
  //         endDate: endDateTemp,
  //         channel: val.channel,
  //         data: convertDataToXls(data?.data || []),
  //       })
  //     } catch (e) {
  //       // tempData.push([{
  //       //   applicationId: application.id,
  //       //   createdDate: application.createdAt,
  //       //   applicationName: application.applicationName,
  //       //   channelId: val.id,
  //       //   channelCode: val.channel,
  //       //   totalTransaction: 0,
  //       //   successRate: `0%`,
  //       //   failedRate: `0%`,
  //       //   startDate: startDateTemp,
  //       //   endDate: endDateTemp,
  //       //   channel: val.channel,
  //       //   data: [],
  //       // }]);
  //       // alert(JSON.stringify(tempData))
  //     }

  //     if (i < application.channels.length) {
  //       setXlsData(tempData);
  //       setXlsLoading(false);
  //     }
  //   });
  //   if (!(application?.channels && application?.channels.length > 0)) {
  //     setXlsData([]);
  //     setXlsLoading(false);
  //   };
  //   return true;
  // }

  // const convertDataToXls = (data) => {
  //   const temp = [];
  //   data.map((val) => {
  //     return temp.push({
  //       date: moment(val.date).format("YYYY-MM-DD"),
  //       // eslint-disable-next-line radix
  //       requestSuccess: parseInt(val?.requestSuccess),
  //       // eslint-disable-next-line radix
  //       requestFailed: parseInt(val?.requestFailed),
  //     });
  //   });
  //   return temp;
  // }

  const dataDownload = {
    // application_id: "5d395e79c546bb57b84e2a9c",
    // application_id: "5d395e79c546bb57b84e2a9c",
    startDate: startDateTemp,
    endDate: endDateTemp,
    // page: 1,
    // limit: 10,
    // showType: isFilterData !== '' ? isFilterData : 'all',
    // search: 'a',
    // sortBy: "created_at"
  }

  async function downloadReport() {
    if (selectedChannel?.channelName === "sms") {
      const applicationData = applicationId
      const params = new URLSearchParams(dataDownload);
      reportSvc.axiosSMSDownload(params, applicationData)
        .then(res => {
          if (res?.data !== null && res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = "report_sms";
            setXlsLoading(true);
            reportSvc.axiosSMSDownloadBuffer(params, applicationData)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
                setXlsLoading(false);
              }).catch(() => {
                Alert.showStatus(
                  AlertType.ERROR,
                  'Error!',
                  'Something went wrong or Data Is Empty'
                )
                setXlsLoading(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
            setXlsLoading(false);
          }
        })
        .catch(() => {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            'Something went wrong or Data Is Empty'
          )
          setXlsLoading(false);
        })
    } else if (selectedChannel?.channelName === "sms_otp") {
      const applicationData = applicationId
      const params = new URLSearchParams(dataDownload);
      reportSvc.axiosSMSOTPDownload(params, applicationData)
        .then(res => {
          if (res?.data !== null && res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = "report_sms_otp";
            setXlsLoading(true);
            reportSvc.axiosSMSOTPDownloadBuffer(params, applicationData)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
                setXlsLoading(false);
              }).catch(() => {
                Alert.showStatus(
                  AlertType.ERROR,
                  'Error!',
                  'Something went wrong or Data Is Empty'
                )
                setXlsLoading(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
            setXlsLoading(false);
          }
        })
        .catch(() => {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            'Something went wrong or Data Is Empty'
          )
          setXlsLoading(false);
        })
    } else if (selectedChannel?.channelName === "call") {
      const applicationData = applicationId
      const params = new URLSearchParams(dataDownload);
      reportSvc.axiosCallDownload(params, applicationData)
        .then(res => {
          if (res?.data !== null && res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = "report_call";
            setXlsLoading(true);
            reportSvc.axiosCallDownloadBuffer(params, applicationData)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
                setXlsLoading(false);
              }).catch(() => {
                Alert.showStatus(
                  AlertType.ERROR,
                  'Error!',
                  'Something went wrong or Data Is Empty'
                )
                setXlsLoading(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
            setXlsLoading(false);
          }
        })
        .catch(() => {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            'Something went wrong or Data Is Empty'
          )
          setXlsLoading(false);
        })
    } else if (selectedChannel?.channelName === "voice_otp") {
      const applicationData = applicationId
      const params = new URLSearchParams(dataDownload);
      reportSvc.axiosCallDownload(params, applicationData)
        .then(res => {
          if (res?.data !== null && res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = "report_call_otp";
            setXlsLoading(true);
            reportSvc.axiosCallDownloadBuffer(params, applicationData)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
                setXlsLoading(false);
              }).catch(() => {
                Alert.showStatus(
                  AlertType.ERROR,
                  'Error!',
                  'Something went wrong or Data Is Empty'
                )
                setXlsLoading(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
            setXlsLoading(false);
          }
        })
        .catch(() => {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            'Something went wrong or Data Is Empty'
          )
          setXlsLoading(false);
        })
    } else if (selectedChannel?.channelName === "email") {
      const applicationData = applicationId
      const params = new URLSearchParams(dataDownload);
      reportSvc.axiosEmailDownload(params, applicationData)
        .then(res => {
          if (res?.data !== null && res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = "report_email";
            setXlsLoading(true);
            reportSvc.axiosEmailDownloadBuffer(params, applicationData)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
                setXlsLoading(false);
              }).catch(() => {
                Alert.showStatus(
                  AlertType.ERROR,
                  'Error!',
                  'Something went wrong or Data Is Empty'
                )
                setXlsLoading(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
            setXlsLoading(false);
          }
        })
        .catch(() => {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            'Something went wrong or Data Is Empty'
          )
          setXlsLoading(false);
        })
    } else if (selectedChannel?.channelName === "whatsapp") {
      const applicationData = applicationId
      const params = new URLSearchParams(dataDownload);
      reportSvc.axiosWhatsappDownload(params, applicationData)
        .then(res => {
          if (res?.data !== null && res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = "report_whatsapp";
            setXlsLoading(true);
            reportSvc.axiosWhatsappDownloadBuffer(params, applicationData)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
                setXlsLoading(false);
              }).catch(() => {
                Alert.showStatus(
                  AlertType.ERROR,
                  'Error!',
                  'Something went wrong or Data Is Empty'
                )
                setXlsLoading(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
            setXlsLoading(false);
          }
        })
        .catch(() => {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            'Something went wrong or Data Is Empty'
          )
          setXlsLoading(false);
        })
    }
  }

  useEffect(() => {
    // getXlsData();
    setMeta(({}));
    setReport(getGrapichData([]));

    if (applications.length > 0) {
      switch (selectedChannel?.channelName) {
        case 'whatsapp':
          getReportWhatsapp()
          geChartWhatsapp()
          getDataUserWATable()
          break;

        case 'email':
          getUsageEmail()
          getReportEmail()
          getDataUserEmailTable()
          break;

        case 'call':
          getReportCall()
          getUsageCall();
          getDataUserCallTable()
          break;

        case 'voice_otp':
          getReportCallOTP()
          getDataUserCallOtpTable()
          break;

        case 'sms':
          getReportSMS()
          geChartSMS()
          getDataUserSMSTable()
          break;

        case 'sms_otp':
          getReportSMSOTP()
          geChartOTPSMS()
          getDataUserSMSOTPTable()
          break;

        default:
          break;
      }
    }

  }, [applications, selectedApplication, selectedChannel, rangeDate]);

  function getReportWhatsapp() {
    const params = applicationId
    const dataUser = {
      "startDate": startDateTemp,
      "endDate": endDateTemp,
    }
    setDataLoading(true);
    reportSvc.axiosWhatsappReport(dataUser, params).then((response) => {
      const data = response.data || {};
      for (let index = 0; index < data.datas.length; index++) {
        const result = data.datas[index];
        const element = data.datas[index];
        element.resultSucces = result.delivered + result.read;
        element.resultFailed = result.failed + result.rejected + result.submitted;
      }
     
      // setReport(getGrapichData(data.datas));
      data.succesRate = data.totalDelivered > 0 || data.totalRead > 0 ? 
      (data.totalDelivered + data.totalRead) / data.totalRecord*100 : 
      data.totalDelivered;
      data.failedRate = data.totalFailed > 0 || data.totalRejected > 0 || data.totalSubmitted > 0 ? 
      (data.totalFailed + data.totalRejected + data.totalSubmitted) / data.totalRecord*100 : 
      data.totalFailed;
      setMeta(data);
      setDataLoading(false);
    }).catch(() => { setDataLoading(false); });
  }

  const geChartWhatsapp = async () => {
    setDataLoading(true);
    const appId = applicationId
    const reqBody = {
      startDate: startDateTemp,
      endDate: endDateTemp,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosChartSessionWhatsapp(reqBody, appId)
      if(result.data){
        setReport(getGrapichWAUsage(result.data));
        setDataLoading(false);
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {setDataLoading(false);}
  }

  async function getDataUserWATable() {
    let dataFilter = isFilterTable;
    dataFilter.application_id = applicationId;
    dataFilter.startDate = startDateTemp;
    dataFilter.endDate = endDateTemp;
    
    setDataUser([])
    setDataLoading(true);
    await applicationSvc.generateSWaRecord(applicationId,dataFilter)
      .then(response => {
        setDataUser(response.data.data)
      })
      .catch(error => {
        setDataLoading(false);
        console.log(error)
      })
      setDataLoading(false);
  }
  
  // get Usage and Report graphic email
  const getUsageEmail = async () => {
    const appId = applicationId
    const reqParams = {
      start_date: startDateTemp,
      end_date: endDateTemp,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosUsageEmail(reqParams, appId)
      if(result.data){
        setReport(getGrapichEmailUsage(result.data.total));
        console.log('result email', result.data)
        setDataUsageChannel(result.data)
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {}
  }

  function getReportEmail() {
    const params = applicationId
    const dataUser = {
      "startDate": startDateTemp,
      "endDate": endDateTemp,
    }
    setDataLoading(true);
    reportSvc.axiosEmailReport(dataUser, params).then((response) => {
      const data = response.data || {};

      for (let index = 0; index < data.datas.length; index++) {
        const result = data.datas[index];
        const element = data.datas[index];
        element.resultSucces = result.delivered + result.clicked + result.opened + result.submitted;
        element.resultFailed = result.failed + result.unsubscribe;
      }

      // setReport(getGrapichData(data.datas));
      data.succesRate = data.totalDelivered > 0 || data.totalClicked > 0 || data.totalOpened > 0 || data.totalSubmitted > 0 ? 
      (data.totalDelivered + data.totalClicked + data.totalOpened + data.totalSubmitted)/data.totalRecord*100 : 
      data.totalDelivered;
      data.failedRate = data.totalFailed > 0 || data.totalUnsubscribe > 0 ? 
      (data.totalFailed + data.totalUnsubscribe)/data.totalRecord*100 : 
      data.totalFailed;
      setMeta(data);
      setDataLoading(false);
    }).catch(() => { setDataLoading(false); });
  }

  async function getDataUserEmailTable() {
    let dataFilter = isFilterTable;
    dataFilter.application_id = applicationId;
      dataFilter.startDate = startDateTemp;
    dataFilter.endDate = endDateTemp;
    
    setDataUser([])
    setDataLoading(true);
    await applicationSvc.generateEmailRecord(applicationId,dataFilter)
      .then(response => {
        setDataUser(response.data.data)
      })
      .catch(error => {
        setDataLoading(false);
        console.log(error)
      })
      setDataLoading(false);
  }

  // get Usage and Report graphic Call
  const getUsageCall = async () => {
    const appId = applicationId
    const reqBody = {
      start_date: startDateTemp,
      end_date: endDateTemp,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosUsageCall(reqBody, appId)
      if(result.data){
        setReport(getGrapicCallUsage(result.data.total));
        setDataUsageChannel(result.data)
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {}
  }

  function getReportCall() {
    const params = applicationId
    const dataUser = {
      "startDate": startDateTemp,
      "endDate": endDateTemp,
    }
    setDataLoading(true);
    reportSvc.axiosCallReport(dataUser, params).then((response) => {
      const data = response.data || {};
      for (let index = 0; index < data.datas.length; index++) {
        const result = data.datas[index];
        const element = data.datas[index];
        element.resultSucces = result.delivered + result.submitted + result.answered;
        element.resultFailed = result.failed + result.user_busy + result.rna;
      }

      // setReport(getGrapichData(data.datas));
      data.succesRate = data.totalSent > 0 || data.totaldelivered > 0 || data.totalSubmitted > 0 || data.totalAnswered > 0 ? 
      (data.totalSent + data.totaldelivered + data.totalSubmitted + data.totalAnswered) /data.totalRecord*100 : 
      data.totalSent;
      data.failedRate = data.totalFailed > 0 || data.totalUndelivered > 0 || data.totalUser_busy > 0 || data.totalRna > 0 ? 
      (data.totalFailed + data.totalUndelivered + data.totalUser_busy + data.totalRna) / data.totalRecord*100 : 
      data.totalFailed;
      setMeta(data);
      setDataLoading(false);
    }).catch(() => { setDataLoading(false); });
  }

  async function getDataUserCallTable() {
    let dataFilter = isFilterTable;
    dataFilter.application_id = applicationId;
      dataFilter.startDate = startDateTemp;
    dataFilter.endDate = endDateTemp;
    
    setDataUser([])
    setDataLoading(true);
    await applicationSvc.generateCallRecord(applicationId,dataFilter)
      .then(response => {
        setDataUser(response.data.data)
      })
      .catch(error => {
        setDataLoading(false);
        console.log(error)
      })
      setDataLoading(false);
  }

  function getReportCallOTP() {
    const params = applicationId
    const dataUser = {
      "startDate": startDateTemp,
      "endDate": endDateTemp,
    }
    setDataLoading(true);
    reportSvc.axiosCallOTPReport(dataUser, params).then((response) => {
      const data = response.data || {};
      for (let index = 0; index < data.datas.length; index++) {
        const result = data.datas[index];
        const element = data.datas[index];
        element.resultSucces = result.success + result.submitted + result.answered;
        element.resultFailed = result.failed + result.rna;
      }

      setReport(getGrapichData(data.datas));
      data.succesRate = data.totalSuccess > 0 || data.totalSubmitted > 0 || data.totalAnswered > 0 ? 
      (data.totalSent + data.totalSuccess + data.totalSubmitted + data.totalAnswered) / data.totalRecord*100 : 
      data.totalSuccess;
      data.failedRate = data.totalFailed > 0 || data.totalUndelivered > 0  || data.totalRna > 0 ? 
      (data.totalFailed + data.totalUndelivered + data.totalRna)/data.totalRecord*100 : 
      data.totalFailed;
      setMeta(data);
      setDataLoading(false);
    }).catch(() => { setDataLoading(false); });
  }

  async function getDataUserCallOtpTable() {
    let dataFilter = isFilterTable;
    dataFilter.application_id = applicationId;
      dataFilter.startDate = startDateTemp;
    dataFilter.endDate = endDateTemp;
    
    setDataUser([])
    setDataLoading(true);
    await applicationSvc.generateCallOtpRecord(applicationId,dataFilter)
      .then(response => {
        setDataUser(response.data.data)
      })
      .catch(error => {
        setDataLoading(false);
        console.log(error)
      })
      setDataLoading(false);
  }

  // SMS API
  function getReportSMS() {
    const params = applicationId
    const dataUser = {
      "startDate": startDateTemp,
      "endDate": endDateTemp,
    }
    setDataLoading(true);
    reportSvc.axiosSMSReport(dataUser, params).then((response) => {
      const data = response.data || {};
      for (let index = 0; index < data.datas.length; index++) {
        const result = data.datas[index];
        const element = data.datas[index];
        element.resultSucces = result.sent + result.submitted + result.delivered;
        element.resultFailed = result.failed + result.undelivered;
      }

      // setReport(getGrapichData(data.datas));

      data.succesRate = data.totalSent > 0 || data.totalDelivered > 0 || data.totalSubmitted > 0 ? 
        (data.totalSent + data.totalDelivered + data.totalSubmitted) / data.totalRecord*100 : 
        data.totalSent;
      data.failedRate = data.totalFailed > 0 || data.totalUndelivered > 0 ? 
        (data.totalFailed + data.totalUndelivered)/data.totalRecord*100 : 
        data.totalFailed;
      setMeta(data);
      setDataLoading(false);
    }).catch(() => { setDataLoading(false); });
  }

  const geChartSMS = async () => {
    setDataLoading(true);
    const appId = applicationId
    const reqBody = {
      startDate: startDateTemp,
      endDate: endDateTemp,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosGraphicSMS(reqBody, appId)
      if(result.data){
        setReport(getGrapichSMSUsage(result.data));
        setDataLoading(false);
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {setDataLoading(false);}
  }

  async function getDataUserSMSTable() {
    let dataFilter = isFilterTable;
    dataFilter.application_id = applicationId;
      dataFilter.startDate = startDateTemp;
    dataFilter.endDate = endDateTemp;
    
    setDataUser([])
    setDataLoading(true);
    await applicationSvc.generateSmsRecord(applicationId,dataFilter)
      .then(response => {
        setDataUser(response.data.data)
      })
      .catch(error => {
        setDataLoading(false);
        console.log(error)
      })
      setDataLoading(false);
  }

  function getReportSMSOTP() {
    const params = applicationId
    const dataUser = {
      "startDate": startDateTemp,
      "endDate": endDateTemp,
    }
    setDataLoading(true);
    reportSvc.axiosSMSOTPReport(dataUser, params).then((response) => {
      const data = response.data || {};
      for (let index = 0; index < data.datas.length; index++) {
        const result = data.datas[index];
        const element = data.datas[index];
        element.resultSucces = result.sent + result.delivered + result.submitted;
        element.resultFailed = result.failed + result.undelivered;

      }
     
      // setReport(getGrapichData(data.datas));
     
      data.succesRate = data.totalSent > 0 || data.totalDelivered > 0 || data.totalSubmitted > 0 ? 
      (data.totalSent + data.totalDelivered + data.totalSubmitted) / data.totalRecord*100 : data.totalSent;
      data.failedRate = data.totalFailed > 0 || data.totalUndelivered > 0 ? 
      (data.totalFailed + data.totalUndelivered)/data.totalRecord*100 : data.totalFailed;
      setMeta(data);
      setDataLoading(false);
    }).catch(() => { setDataLoading(false); });
  }

  const geChartOTPSMS = async () => {
    setDataLoading(true);
    const appId = applicationId
    const reqBody = {
      startDate: startDateTemp,
      endDate: endDateTemp,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosGraphicOTPSMS(reqBody, appId)
      if(result.data){
        setReport(getGrapichOTPSMSUsage(result.data));
        setDataLoading(false);
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {setDataLoading(false);}
  }

  async function getDataUserSMSOTPTable() {
    let dataFilter = isFilterTable;
    dataFilter.application_id = applicationId;
      dataFilter.startDate = startDateTemp;
    dataFilter.endDate = endDateTemp;
    
    setDataUser([])
    setDataLoading(true);
    await applicationSvc.generateSmsOTP(applicationId,dataFilter)
      .then(response => {
        setDataUser(response.data.data)
      })
      .catch(error => {
        setDataLoading(false);
        console.log(error)
      })
      setDataLoading(false);
  }
  // END SMS

  // GRAPHIC CHANNEL SCHEME
  const getGrapichData = (reportData) => {
    const labels = [];
    const datasets = [{
      label: 'Total Success',
      fill: true,
      lineTension: 0,
      borderColor: 'steelblue',
      borderWidth: 2,
      data: []
    }, {
      label: 'Total Failed',
      fill: true,
      lineTension: 0,
      borderColor: '#C94242',
      borderWidth: 2,
      data: []
    }];

    reportData.map((val) => {
      // console.log('items', val, reportData, datasets)
       if(startDateTemp === endDateTemp){
          labels.push(moment.utc(val.created_at || val.date).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.created_at || val.date).add("day").format("DD MMM"));
       }
    
      datasets[0].data.push(val.resultSucces);
      datasets[1].data.push(val.resultFailed);
      return true;
    });

    return {
      labels,
      datasets
    }
  }

  const getGrapichWAUsage = (reportData) => {
    const labels = [];
      const datasets = [{
      label: 'Total Delivered',
      fill: true,
      lineTension: 0,
      borderColor: '#219653',
      borderWidth: 2,
      data: []
    }, 
    {
      label: 'Total Read',
      fill: true,
      lineTension: 0,
      borderColor: '#1D67CB',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Submitted',
      fill: true,
      lineTension: 0,
      borderColor: '#FF8B00',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Rejected',
      fill: true,
      lineTension: 0,
      borderColor: '#6E0022',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Failed',
      fill: true,
      lineTension: 0,
      borderColor: '#EB5757',
      borderWidth: 2,
      data: []
    }];

    reportData.map((val) => {
      // console.log('items', val, reportData, datasets)
       if(startDateTemp === endDateTemp){
          labels.push(moment.utc(val.created_at || val.date).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.created_at || val.date).add("day").format("DD MMM"));
       }
    
       datasets[0].data.push(val.total_delivered);
       datasets[1].data.push(val.total_read);
       datasets[2].data.push(val.total_submitted);
       datasets[3].data.push(val.total_rejected);
       datasets[4].data.push(val.total_failed);
      return true;
    });

    return {
      labels,
      datasets
    }
  }

  const getGrapichEmailUsage = (reportData) => {
    const labels = [];
      const datasets = [{
      label: 'Total Delivered',
      fill: true,
      lineTension: 0,
      borderColor: '#219653',
      borderWidth: 2,
      data: []
    }, 
    {
      label: 'Total Opened',
      fill: true,
      lineTension: 0,
      borderColor: '#1D67CB',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Clicked',
      fill: true,
      lineTension: 0,
      borderColor: '#FF276B',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Failed by system',
      fill: true,
      lineTension: 0,
      borderColor: '#EB5757',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Failed by mail server',
      fill: true,
      lineTension: 0,
      borderColor: '#6E0022',
      borderWidth: 2,
      data: []
    }];

    reportData.map((val) => {
      // console.log('items', val, reportData, datasets)
       if(startDateTemp === endDateTemp){
          labels.push(moment.utc(val.created_at || val.date).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.created_at || val.date).add("day").format("DD MMM"));
       }
    
       datasets[0].data.push(val.total_delivered);
       datasets[1].data.push(val.total_opened);
       datasets[2].data.push(val.total_clicked);
       datasets[3].data.push(val.total_failed);
       datasets[4].data.push(val.total_failed_server);
      return true;
    });

    return {
      labels,
      datasets
    }
  }

  const getGrapicCallUsage = (reportData) => {
    const labels = [];
      const datasets = [{
      label: 'Total In Call',
      fill: true,
      lineTension: 0,
      borderColor: '#A358F2',
      borderWidth: 2,
      data: []
    }, 
    {
      label: 'Total Answered',
      fill: true,
      lineTension: 0,
      borderColor: '#1D67CB',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total RNA',
      fill: true,
      lineTension: 0,
      borderColor: '#6E0022',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Failed',
      fill: true,
      lineTension: 0,
      borderColor: '#EB5757',
      borderWidth: 2,
      data: []
    }];

    reportData.map((val) => {
      // console.log('items', val, reportData, datasets)
       if(startDateTemp === endDateTemp){
          labels.push(moment.utc(val.created_at || val.date).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.created_at || val.date).add("day").format("DD MMM"));
       }
    
       datasets[0].data.push(val.total_in_call);
       datasets[1].data.push(val.total_answered);
       datasets[2].data.push(val.total_rna);
       datasets[3].data.push(val.total_failed);
      return true;
    });

    return {
      labels,
      datasets
    }
  }

  const getGrapichSMSUsage = (reportData) => {
    const labels = [];
      const datasets = [{
      label: 'Total Sent',
      fill: true,
      lineTension: 0,
      borderColor: '#1D67CB',
      borderWidth: 2,
      data: []
    }, 
    {
      label: 'Total Delivered',
      fill: true,
      lineTension: 0,
      borderColor: '#219653',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Submitted',
      fill: true,
      lineTension: 0,
      borderColor: '#FF8B00',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Failed',
      fill: true,
      lineTension: 0,
      borderColor: '#EB5757',
      borderWidth: 2,
      data: []
    }];

    reportData.map((val) => {
      // console.log('items', val, reportData, datasets)
       if(startDateTemp === endDateTemp){
          labels.push(moment.utc(val.created_at || val.date).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.created_at || val.date).add("day").format("DD MMM"));
       }
    
       datasets[0].data.push(val.total_sent);
       datasets[1].data.push(val.total_delivered);
       datasets[2].data.push(val.total_submitted);
       datasets[3].data.push(val.total_failed);
      return true;
    });

    return {
      labels,
      datasets
    }
  }

  const getGrapichOTPSMSUsage = (reportData) => {
    const labels = [];
      const datasets = [{
      label: 'Total Sent',
      fill: true,
      lineTension: 0,
      borderColor: '#1D67CB',
      borderWidth: 2,
      data: []
    }, 
    {
      label: 'Total Delivered',
      fill: true,
      lineTension: 0,
      borderColor: '#219653',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Submitted',
      fill: true,
      lineTension: 0,
      borderColor: '#FF8B00',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Total Failed',
      fill: true,
      lineTension: 0,
      borderColor: '#EB5757',
      borderWidth: 2,
      data: []
    }];

    reportData.map((val) => {
      // console.log('items', val, reportData, datasets)
       if(startDateTemp === endDateTemp){
          labels.push(moment.utc(val.created_at || val.date).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.created_at || val.date).add("day").format("DD MMM"));
       }
    
       datasets[0].data.push(val.total_sent);
       datasets[1].data.push(val.total_delivered);
       datasets[2].data.push(val.total_submitted);
       datasets[3].data.push(val.total_failed);
      return true;
    });

    return {
      labels,
      datasets
    }
  }
  // END GRAPHIC SHEMA

  const RenderBox = (props) => {
    const { className, label, value, arrow, percentage, last, variant } = props;
    return (
      <Detail className={className} last={last}>
        <Label className="margin-left-20">{label}</Label>
        <Value 
          className={`margin-left-20 no-margin-bottom 
          ${variant === 'success' && 'cl-light-blue' }
          ${variant === 'total_data' && 'cl-black' }
          ${variant === 'failed' && 'cl-red' }`}>
            {value || 0}
          </Value>
        {/* <Percentage className="no-margin-bottom">
          <Icon className="margin-left-20 margin-right-4" src={arrow || Svg.arrow_up.default} />
          {percentage || `0`}
        </Percentage> */}
      </Detail>
    )
  }

  const handleRangeDate = (value) => {
    if (moment(value[1]).diff(moment(value[0]), 'months') < 1) {
      setRangeDate(value);
    } 
  }

  useEffect(()=>{
    setTextDate(formatDate(new Date().setDate(new Date().getDate() - 7)) + ' - ' + formatDate(new Date()))
  },[])

  function handleRedirectTo(){
    let data = applications[selectedApplication]
    let dataPayload = {
      startDate: startDateTemp,
      endDate: endDateTemp,
      application_id:applicationId,
      channel:selectedChannel.channelName
    }
    history.push({
      pathname: `/my-application/detail-transaction/${applicationId}`,
      state: { id: applicationId, data, dataPayload},
    });
  }

  let dateRange = useRef()
  function handleClickDate(value){
    dateRange?.current?.show()
  }

  function resetDate(){
    setRangeDate("")
    setTextDate('Select date...');
  }

  function handleOnchangeDate(value) {
    if (value.value ) {
      setRangeDate(value.value);
      setTextDate(formatDate(new Date(value.value[0])) + ' - ' + formatDate(new Date(value.value[1])))

    }else{
      setRangeDate("")
    }
  }

  const RenderSessionWA = useMemo(
    ()=> {
      return (
        <div>
          <div className="border-bottom mt-4"></div>
          <WhatsappSession 
            startDate={startDateTemp} 
            endDate={endDateTemp} 
            applicationId={applicationId} 
            channel={selectedChannel?.channelName} />
          <div className="margin-top-30" >
            <LineGraphic grapichData={report} isStatusDate={isStatusDate}/>
          </div>
        </div>
      )
    }, 
  [selectedChannel?.channelName]
  )

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
        if (container.current && !container.current.contains(event.target)) {
          setDropdown(false);
        }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [container])

  return (
    <div className="wrapper_container w-100">
      <Wrapper className="d-flex flex-column w-100">
        <DivTitle className="d-flex justify-content-md-between margin-bottom-30">
          <div>
            <div className="margin-bottom-0">
              <TitleV2 className="mb-0">Overview</TitleV2>
            </div>
            <H4>View hit rate API transactions, by channel and filter.</H4>
            {/* <BadgeOverview></BadgeOverview> */}
          </div>
          <div className="d-flex flex-row align-items-center d-none" style={{ paddingTop: 16 }}>
            {xlsLoading ? (
              <ButtonExport disabled className="d-none">
                <Icon className="margin-right-12" src={Svg.download.default} />
                <H5 className="fw-bold">
                  Please wait...
                </H5>
              </ButtonExport>
            ) :
              (
                <ButtonExport onClick={downloadReport} className="d-none">
                  <Icon className="margin-right-12" src={Svg.download.default} />
                  <H5 className="fw-bold">
                    Export to XLS
                  </H5>
                </ButtonExport>
              )}
          </div>
        </DivTitle>
        <DivGraphic className="d-flex flex-column p-3">
          <Div project className="d-flex flex-row row justify-content-between pb-1" ref={container}>
            <ButtonProject className="w-auto col-md-6 ms-0" onClick={() => { setDropdown(!dropdown) }}>
              <H3 style={{wordBreak:'break-all'}} className="fw-bold margin-left-10 margin-right-10">{applications[selectedApplication]?.applicationName || applications[selectedApplication]?.application_name || applications[selectedApplication]?._id || "-- Select Application --"}</H3>
              <Icon src={Svg.chevron_right_2.default} />
            </ButtonProject>
            <div style={{width:'unset'}}>
            <DateRangePickerComponent
                delayUpdate={true}
                ref={(scope)=>{dateRange.current = scope}}
                enableRtl={true}
                className='custom-ej2date'
                change={handleOnchangeDate}
                minDays={1}
                maxDays={31}
                value={rangeDate}
                // onClick={handleClickDate}
                placeholder='Choose date'>
                  <PresetsDirective>
                      <PresetDirective label="Today" start={today} end={today}></PresetDirective>
                      <PresetDirective label="Yesterday" start={yesterday} end={today}></PresetDirective>
                      <PresetDirective label="Last 7 Days" start={weekEnd} end={today}></PresetDirective>
                      <PresetDirective label="Last 30 Days" start={monthStart} end={today}></PresetDirective>
                      {/* <PresetDirective label="Last Month" start={lastStart} end={lastEnd}></PresetDirective> */}
                      {/* <PresetDirective label="Last Year" start={yearStart} end={yearEnd}></PresetDirective> */}
                  </PresetsDirective>
            </DateRangePickerComponent>
            <div className="form-control wrap-date-ejs date_detail_page" style={{marginTop:'-24px',position:'relative'}}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.25 3H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3H6.75V2.25C6.75 2.05109 6.67098 1.86032 6.53033 1.71967C6.38968 1.57902 6.19891 1.5 6 1.5C5.80109 1.5 5.61032 1.57902 5.46967 1.71967C5.32902 1.86032 5.25 2.05109 5.25 2.25V3H3.75C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V5.25C16.5 4.65326 16.2629 4.08097 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM15 14.25C15 14.4489 14.921 14.6397 14.7803 14.7803C14.6397 14.921 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.921 3.21967 14.7803C3.07902 14.6397 3 14.4489 3 14.25V9H15V14.25ZM15 7.5H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H5.25V5.25C5.25 5.44891 5.32902 5.63968 5.46967 5.78033C5.61032 5.92098 5.80109 6 6 6C6.19891 6 6.38968 5.92098 6.53033 5.78033C6.67098 5.63968 6.75 5.44891 6.75 5.25V4.5H11.25V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V4.5H14.25C14.4489 4.5 14.6397 4.57902 14.7803 4.71967C14.921 4.86032 15 5.05109 15 5.25V7.5Z" fill="#42526E"/>
              </svg>
              <input
              style={{width:'100%',cursor:'pointer'}} 
                type="text" 
                className='w-full input-time-custom cursor-pointer ms-1 me-1'
                onClick={handleClickDate}
                value={isTextDate}
                required="required"
                placeholder="placetext"/>
                {
                  isTextDate !== 'Select date...' &&
                  <img className='ic-reset pinkic-hover' onClick={resetDate} src={Close}></img>
                }
            </div>
            </div>
            {dropdown && <Dropdown data={applications} handleClick={(i) => { setSelectedApplication(i); setDropdown(false); setSelectedChannel({ index: 0, channelName: '' }); return true; }} />}
          </Div>
          <div className="d-flex">
            <Div className="d-flex row align-items-center w-100">
              {applications[selectedApplication]?.application_channels?.map((val, i) => {
                return (
                  <>
                    {val.channel_name === 'Whatsapp' && (
                      <ButtonMenu active={selectedChannel?.channelName === 'whatsapp'} className="col-md-1 d-flex no-pad w-auto margin-right-20 align-items-center" onClick={() => setSelectedChannel({ index: i, channelName: 'whatsapp' })}>
                        <Icon src={Svg.whatsapp_2.default} />
                        <H3 className="margin-left-10">Whatsapp</H3>
                      </ButtonMenu>
                    )}
                    {val.channel_name === 'SMS' && (
                      <ButtonMenu active={selectedChannel?.channelName === 'sms'} className="col-md-1 d-flex w-auto no-pad margin-right-20 align-items-center" onClick={() => setSelectedChannel({ index: i, channelName: 'sms' })}>
                        <Icon src={Svg.sms_dashboard.default} />
                        <H3 className="margin-left-10">SMS</H3>
                      </ButtonMenu>
                    )}
                    {val.channel_name === 'SMS OTP' && (
                      <ButtonMenu active={selectedChannel?.channelName === 'sms_otp'} className="col-md-1 d-flex w-auto no-pad margin-right-20 align-items-center" onClick={() => setSelectedChannel({ index: i, channelName: 'sms_otp' })}>
                        <Icon src={Svg.sms_dashboard.default} />
                        <H3 className="margin-left-10">SMS OTP</H3>
                      </ButtonMenu>
                    )}
                    {val.channel_name === 'Call' && (
                      <ButtonMenu active={selectedChannel?.channelName === 'call'} className="col-md-1 d-flex w-auto no-pad margin-right-20 align-items-center" onClick={() => setSelectedChannel({ index: i, channelName: 'call' })}>
                        <Icon src={Svg.voice.default} />
                        <H3 className="margin-left-10">Call</H3>
                      </ButtonMenu>
                    )}
                    {/* {val.channel_name === channelConstant.voiceOtp && (
                      <ButtonMenu active={selectedChannel?.channelName === 'voice_otp'} className="col-md-1 d-flex w-auto no-pad margin-right-20 align-items-center" onClick={() => setSelectedChannel({ index: i, channelName: 'voice_otp' })}>
                        <Icon src={Svg.voice.default} />
                        <H3 className="margin-left-10">Voice OTP</H3>
                      </ButtonMenu>
                    )} */}
                    {val.channel_name === 'Email' && (
                      <ButtonMenu active={selectedChannel?.channelName === 'email'} className="col-md-1 d-flex w-auto no-pad margin-right-20 align-items-center" onClick={() => setSelectedChannel({ index: i, channelName: 'email' })}>
                        <Icon src={Svg.email.default} />
                        <H3 className="margin-left-10">Email</H3>
                      </ButtonMenu>
                    )}
                  </>
                )
              })}
            </Div>
          </div>
          <div>
            {isDataLoading && (
              <LoadingPage />
            )}
                
            {!isDataLoading && (
              <div>
                <div className="d-flex row justify-content-between margin-inline-30">
                  <RenderBox
                    className="col mr-10-desktop"
                    label="Total Transaction"
                    value={meta?.totalRecord}
                    variant="total_data"
                  />
                  <RenderBox
                    className="col mr-10-desktop"
                    label="Success Rate"
                    value={`${meta?.succesRate?.toFixed(2) || 0}%`}
                    variant="success"
                  />
                  <RenderBox
                    className="col mr-10-desktop"
                    label="Failed Rate"
                    value={`${meta.failedRate?.toFixed(2) || 0}%`}
                    variant="failed"
                    // last
                  />
                </div>

                {/* DETAIL TRANSCATION */}
                {selectedChannel?.channelName !== '' ? (
                  <DetailTransactionData 
                    startDate={startDateTemp} 
                    endDate={endDateTemp} 
                    applicationId={applicationId} 
                    channel={selectedChannel?.channelName} 
                    isDataUsageChannel={isDataUsageChannel}
                  />
                ) : null}

                {/* Graphic chart usage */}
                {/* {selectedChannel?.channelName === 'sms_otp' ||
                 selectedChannel?.channelName === 'sms' ? (
                <div className="margin-top-30" >
                  <LineGraphic grapichData={report} isStatusDate={isStatusDate}/>
                </div>
                ) : ''} */}


                {/* Graphic multi line */}
                  <div>
                  <div className="margin-top-30" >
                    <GraphicMultiLine grapichData={report} isStatusDate={isStatusDate}/>
                  </div>
                  {selectedChannel?.channelName === 'whatsapp' && (
                    <>
                      <div className="border-bottom mt-4"></div>
                      <WhatsappSession 
                        startDate={startDateTemp} 
                        endDate={endDateTemp} 
                        applicationId={applicationId} 
                        channel={selectedChannel?.channelName} 
                      />
                    </>
                  )}
                  </div>
              </div>
            )}
          </div>
        </DivGraphic>
        {!isDataLoading && (
          <div className="mt-2">
            <div className="p-3 d-flex align-items-center justify-content-between">
              <H2>Monitoring</H2>
              <H4 onClick={handleRedirectTo} className="text-underline" style={{color:'#E81255',fontWeight:'600',cursor:'pointer'}}>View All Monitoring</H4>
            </div>
            <Table data={isDataUser} loading={isDataLoading} valueChannel={selectedChannel?.channelName} />
          </div>
        )}
      </Wrapper>
    </div>
  );
};

export default DashboardPage;
